import React from 'react';
import { YAxis, LineChart, Line, ResponsiveContainer } from 'recharts';
import { Typography, Box } from '@mui/material';

const Chart_Small_MUI = ({ title = 'S&P 500', value = '5,686.67', change = '+1.47%', data = [] }) => {
  const changeColor = change.includes('-') ? 'red' : 'green';

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',  // 🔽 tighter vertical alignment
        px: 0.1,                         // 🔽 slightly reduced padding
      }}
    >
      <Typography
        sx={{
          fontSize: '0.55rem',          // 🔽 smaller title
          color: 'primary.main',
          fontWeight: 600,
          lineHeight: 1,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontSize: '0.60rem',          // 🔽 reduced % font
          color: changeColor,
          lineHeight: 1,
          fontWeight: 500,
        }}
      >
        {change}
      </Typography>

      <Box sx={{ flexGrow: 1, minHeight: 10, maxHeight: '40%' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <YAxis type="number" domain={['dataMin', 'dataMax']} hide />
            <Line
              type="monotone"
              dataKey="value"
              stroke={changeColor}
              strokeWidth={1.2}   // 🔽 thinner line
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default Chart_Small_MUI;
